import axios from './http'

// 新增新闻
export const PostAddNews = params => {
    return axios.post("/news", params).then(res => res.data)
};
// 修改新闻
export const PutEditNews = params => {
    return axios.put("/news", params).then(res => res.data)
};
// 删除新闻
export const DelNews = newsId => {
    return axios.delete(`/news/${newsId}`).then(res => res.data)
};
// 发布新闻
export const PostPubNews = newsId => {
    return axios.put(`/news/publish/${newsId}`).then(res => res.data)
};
// 下架新闻
export const PostOutNews = newsId => {
    return axios.put(`/news/soldout/${newsId}`).then(res => res.data)
};

// 查询新闻列表
export const GetNewsList = query => {
    return axios.get("/news/list", {params: query}).then(res => res.data)
};

// 查询单个新闻
export const GetNewsDetail = newsId => {
    return axios.get(`/news/${newsId}`).then(res => res.data)
};